import { render, staticRenderFns } from "./PayeeInvoiceList.vue?vue&type=template&id=55ed27b4&scoped=true&"
import script from "./PayeeInvoiceList.vue?vue&type=script&lang=ts&"
export * from "./PayeeInvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInvoiceList.vue?vue&type=style&index=0&id=55ed27b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed27b4",
  null
  
)

export default component.exports